export const initFormRecaptcha = () => {
    const form = document.querySelector('#form');
    if (!form) return;

    const refreshToken = () => {
        grecaptcha.execute(form.dataset.recaptchaSiteKey, {action: 'form_submit'})
            .then(function (token) {
                const input = document.querySelector('input[name="g-recaptcha-response"]');
                if (input && window.Livewire) {
                    input.value = token;
                    window.Livewire.find(input.closest('[wire\\:id]').getAttribute('wire:id'))
                        .set('recaptchaResponse', token);
                }
            })
            .catch(function (error) {
                console.error('ReCaptcha error:', error);
            });
    };

    grecaptcha.ready(function () {
        refreshToken();
        setInterval(refreshToken, 60000);
    });

    form.addEventListener('submit', function () {
        grecaptcha.execute(this.dataset.recaptchaSiteKey, {action: 'form_submit'})
            .then(function (token) {
                const input = document.querySelector('input[name="g-recaptcha-response"]');
                if (input && window.Livewire) {
                    input.value = token;
                    window.Livewire.find(input.closest('[wire\\:id]').getAttribute('wire:id'))
                        .set('recaptchaResponse', token);
                }
            });
    });
};
